var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDateFinderWhiteSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDateFinderWhiteSmall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DateFinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datefinder-without-dates",
    transform: "translate(-29.000000, -1342.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDateFinderWhiteSmall",
    transform: "translate(29.264706, 1342.279720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2477376,2.7425139 C33.3523071,2.7425139 34.2477376,3.6379444 34.2477376,4.7425139 L34.2477376,32.4845729 C34.2477376,33.5891424 33.3523071,34.4845729 32.2477376,34.4845729 L2,34.4845729 C0.8954305,34.4845729 0,33.5891424 0,32.4845729 L0,4.7425139 C0,3.6379444 0.8954305,2.7425139 2,2.7425139 L32.2477376,2.7425139 Z M33.247,10.0225139 L1,10.0225139 L1,32.4845729 C1,33.0368576 1.44771525,33.4845729 2,33.4845729 L32.2477376,33.4845729 C32.8000223,33.4845729 33.2477376,33.0368576 33.2477376,32.4845729 L33.247,10.0225139 Z M19.4361791,13.7125695 C20.8455519,13.7125695 22.1703846,14.2605909 23.16679,15.2554412 C25.223145,17.3087169 25.2232841,20.6501482 23.16679,22.7039791 L23.16679,22.7039791 L17.2265951,28.6342146 C17.0164962,28.8439563 16.7411846,28.9487578 16.4660121,28.9487578 C16.1908396,28.9487578 15.915528,28.8439563 15.7055682,28.6343534 L15.7055682,28.6343534 L9.7649561,22.7042568 C8.76827257,21.7094064 8.21945701,20.3865483 8.21945701,18.9797102 C8.21945701,17.5725945 8.76827257,16.250014 9.7649561,15.2553024 C10.7613615,14.2605909 12.0863333,13.7125695 13.495567,13.7125695 C14.5708117,13.7125695 15.5971121,14.0315546 16.4658731,14.624828 C17.334495,14.0316934 18.3609344,13.7125695 19.4361791,13.7125695 Z M32.2477376,3.7425139 L2,3.7425139 C1.44771525,3.7425139 1,4.19022915 1,4.7425139 L1,9.0225139 L33.247,9.0225139 L33.2477376,4.7425139 C33.2477376,4.19022915 32.8000223,3.7425139 32.2477376,3.7425139 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    x: 5.5737389,
    y: 0.5,
    width: 2.80530417,
    height: 5.3484118,
    rx: 1.40265209
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#FFFFFF",
    x: 15.7212167,
    y: 0.5,
    width: 2.80530417,
    height: 5.3484118,
    rx: 1.40265209
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#FFFFFF",
    x: 25.8686945,
    y: 0.5,
    width: 2.80530417,
    height: 5.3484118,
    rx: 1.40265209
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateFinderWhiteSmall);
export default __webpack_public_path__ + "static/media/icDateFinderWhiteSmall.0303d93f303c12987ef114245da3f185.svg";
export { ForwardRef as ReactComponent };